import { render, staticRenderFns } from "./toUpload.vue?vue&type=template&id=60d4bda5&scoped=true"
import script from "./toUpload.vue?vue&type=script&lang=js"
export * from "./toUpload.vue?vue&type=script&lang=js"
import style0 from "./toUpload.vue?vue&type=style&index=0&id=60d4bda5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d4bda5",
  null
  
)

export default component.exports